import { toast as sonnerToast, type ExternalToast } from "sonner";

export const toast = {
	...sonnerToast,
	error: (message: string | React.ReactNode, options?: ExternalToast) => sonnerToast.error(message, { duration: Infinity, ...options }),
};

export const toastActionClassName = "!bg-brand-solid !text-brand-secondary hover:!bg-brand-solid_hover";

/**
 * Dismisses any visible toast. Returns true if one was showing, so callers
 * (e.g. an Escape handler) can let dismissing take precedence over other actions.
 */
export function dismissVisibleToast(): boolean {
	const hasToast =
		document.querySelector('[data-sonner-toast]:not([data-removed="true"])') !==
		null;
	if (hasToast) {
		sonnerToast.dismiss();
	}
	return hasToast;
}